module.exports = __webpack_public_path__ + "img/open.c348977f.png";